// Point d'entrée : monte <App> dans #root sous StrictMode.
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles.css';
import { App } from './App';

const el = document.getElementById('root');
if (!el) throw new Error('#root introuvable');
createRoot(el).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
